// Usando fetch nativo en lugar de axios para mejor compatibilidad móvil
// Usar proxy PHP en producción para evitar problemas CORS en móvil
const USE_PROXY = window.location.hostname !== 'localhost';
const API_URL = USE_PROXY
  ? '/api-proxy.php?path='
  : 'https://misgolpes-backend-production.up.railway.app/api';

const buildUrl = (path) => {
  if (USE_PROXY) {
    // Remover el /api/ inicial del path para el proxy
    const cleanPath = path.replace('/api/', '').replace(/^\//, '');
    return `${API_URL}${cleanPath}`;
  }
  return `${API_URL}${path}`;
};

const fetchWithTimeout = async (path, options = {}, timeout = 30000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const url = buildUrl(path);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    });

    clearTimeout(id);

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Error en la petición' }));
      const err = new Error(error.error || `HTTP Error ${response.status}`);
      err.response = { status: response.status, data: error };
      throw err;
    }

    const data = await response.json();
    // Retornar en formato compatible con axios (con .data)
    return { data };
  } catch (error) {
    clearTimeout(id);
    console.error('API Error:', {
      url,
      method: options.method || 'GET',
      message: error.message,
      name: error.name
    });
    throw error;
  }
};

// Campos
export const camposAPI = {
  getAll: () => fetchWithTimeout('/campos'),
  getById: (id) => fetchWithTimeout(`/campos/${id}`),
  create: (data) => fetchWithTimeout('/campos', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  update: (id, data) => fetchWithTimeout(`/campos/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  delete: (id) => fetchWithTimeout(`/campos/${id}`, {
    method: 'DELETE'
  }),
  getHoyos: (id) => fetchWithTimeout(`/campos/${id}/hoyos`),
  addHoyo: (id, data) => fetchWithTimeout(`/campos/${id}/hoyos`, {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  updateHoyo: (campoId, hoyoId, data) => fetchWithTimeout(`/campos/${campoId}/hoyos/${hoyoId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  deleteHoyo: (campoId, hoyoId) => fetchWithTimeout(`/campos/${campoId}/hoyos/${hoyoId}`, {
    method: 'DELETE'
  })
};

// Partidas
export const partidasAPI = {
  create: (data) => fetchWithTimeout('/partidas', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  getByCode: (codigo) => fetchWithTimeout(`/partidas/${codigo}`),
  join: (codigo, data) => fetchWithTimeout(`/partidas/${codigo}/join`, {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  start: (codigo) => fetchWithTimeout(`/partidas/${codigo}/start`, {
    method: 'POST'
  }),
  finish: (codigo) => fetchWithTimeout(`/partidas/${codigo}/finish`, {
    method: 'POST'
  }),
  getRanking: (codigo) => fetchWithTimeout(`/partidas/${codigo}/ranking`),
  getEstadisticas: (codigo) => fetchWithTimeout(`/partidas/${codigo}/estadisticas`)
};

// Golpes
export const golpesAPI = {
  incrementar: (data) => fetchWithTimeout('/golpes/incrementar', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  decrementar: (data) => fetchWithTimeout('/golpes/decrementar', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  registrarDrop: (data) => fetchWithTimeout('/golpes/drop', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  registrarMulligan: (data) => fetchWithTimeout('/golpes/mulligan', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  getByJugador: (jugadorId) => fetchWithTimeout(`/golpes/jugador/${jugadorId}`),
  finalizarHoyo: (data) => fetchWithTimeout('/golpes/finalizar', {
    method: 'POST',
    body: JSON.stringify(data)
  })
};

export default { camposAPI, partidasAPI, golpesAPI };
